import { useSetAtom } from 'jotai';
import { RESET } from 'jotai/utils';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import useRuleData from './useRuleData';

import {
  atomActionNodeInfo,
  atomCurrentFormType,
  atomFormFieldsStatusAtom,
  atomIsConditionFormComplete,
  atomIsTriggerFormComplete,
  atomRuleData,
  atomRuleDataRaw,
  atomRuleTypeSelected,
  atomToggleActivateRuleModal,
  atomTouchRules,
} from '@/modules/RulesModule/atoms/rules';

export const useResetRulesState = () => {
  const { actionId } = useParams();

  const setCurrentFormType = useSetAtom(atomCurrentFormType);
  const setToggleActivateRuleModal = useSetAtom(atomToggleActivateRuleModal);

  const setIsTriggerFormComplete = useSetAtom(atomIsTriggerFormComplete);
  const setIsConditionFormComplete = useSetAtom(atomIsConditionFormComplete);
  const setActionNodeInfo = useSetAtom(atomActionNodeInfo);
  const setRuleTypeSelected = useSetAtom(atomRuleTypeSelected);
  const setTouchRules = useSetAtom(atomTouchRules);
  const setFormFieldsStatus = useSetAtom(atomFormFieldsStatusAtom);

  const setRuleData = useSetAtom(atomRuleData);
  const setRuleDataRaw = useSetAtom(atomRuleDataRaw);

  const { refetch: refetchRuleData } = useRuleData(Number(actionId));

  const resetUIStates = useCallback(() => {
    setCurrentFormType(RESET);
    setToggleActivateRuleModal(RESET);
  }, [setCurrentFormType, setToggleActivateRuleModal]);

  const resetFormStates = useCallback(() => {
    setIsTriggerFormComplete(RESET);
    setIsConditionFormComplete(RESET);
    setActionNodeInfo(RESET);
    setRuleTypeSelected(RESET);
    setTouchRules(RESET);
    setFormFieldsStatus(RESET);
  }, [
    setActionNodeInfo,
    setFormFieldsStatus,
    setIsConditionFormComplete,
    setIsTriggerFormComplete,
    setRuleTypeSelected,
    setTouchRules,
  ]);

  const resetDataStates = useCallback(() => {
    setRuleData(RESET);
    setRuleDataRaw(RESET);
  }, [setRuleData, setRuleDataRaw]);

  const resetAllAtomStates = useCallback(() => {
    resetUIStates();
    resetFormStates();
    resetDataStates();
  }, [resetDataStates, resetFormStates, resetUIStates]);

  const refetchData = useCallback(() => {
    refetchRuleData();
  }, [refetchRuleData]);

  return {
    refetchData,
    resetAllAtomStates,
  };
};
